import { useSelector, useDispatch } from 'react-redux';
import { useMemo } from 'react';
import { filterRegistry } from './filterRegistry';
import type { RootState } from '@forvalter/store';
import type { MUIDataTableColumn } from 'mui-datatables';
import type { FilterTableKey } from './config';

export function usePersistentFilters(tableKey: FilterTableKey) {
    const dispatch = useDispatch();
    const registryEntry = filterRegistry[tableKey];

    if (!registryEntry) {
        console.error(`No registry entry found for key: ${tableKey}`);
    }

    const savedFilterList = useSelector((state: RootState) =>
        registryEntry.selector(state),
    );

    const handleFilterChange = useMemo(() => {
        return (
            _changedColumn: string | MUIDataTableColumn | null,
            filterList: Array<Array<string>>,
        ) => {
            const isEmpty = filterList.every((f) => f.length === 0);

            if (isEmpty) {
                dispatch(registryEntry.clear());
            } else {
                dispatch(registryEntry.save(filterList));
            }
        };
    }, [dispatch, registryEntry]);

    return {
        savedFilterList,
        handleFilterChange,
    };
}
